import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

export default function CloseButton(props) {

    const classes = useStyles();

    return (
        <button className={classes.closeButton} onClick={() => props.closeDialog()}>{props.text}</button>
    );
}


const useStyles = makeStyles(() => ({

    closeButton: {
        border: "1px solid red",
        cursor: "pointer",
        backgroundColor: "white",
        margin: "10px",
        height:"40px",
        width:"60px",
        color:"red",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
    }
}));
